import React from 'react';
import { Control, FieldPath, FieldValues } from 'react-hook-form';

import { FormControl, FormItem, FormLabel, FormMessage, FormField as ShadcnFormField } from '@/components/ui/form';
import { Select, SelectContent, SelectTrigger, SelectValue } from '@/components/ui/select';

interface FormSelectProps<TFieldValues extends FieldValues> {
    control: Control<TFieldValues>;
    name: FieldPath<TFieldValues>;
    label: string;
    placeholder?: string;
    disabled?: boolean;
    children: React.ReactNode;
}

export function FormSelect<TFieldValues extends FieldValues>({
    control,
    name,
    label,
    placeholder,
    disabled = false,
    children,
}: FormSelectProps<TFieldValues>) {
    return (
        <ShadcnFormField
            control={control}
            name={name}
            render={({ field }) => (
                <FormItem>
                    <FormLabel>{label}</FormLabel>
                    <Select onValueChange={field.onChange} value={field.value} disabled={disabled}>
                        <FormControl>
                            <SelectTrigger>
                                <SelectValue placeholder={placeholder} />
                            </SelectTrigger>
                        </FormControl>
                        <SelectContent position="popper" sideOffset={4}>
                            {children}
                        </SelectContent>
                    </Select>
                    <FormMessage />
                </FormItem>
            )}
        />
    );
}
